<!-- 百分比上传组件 -->

<template>
<div class="load-btn">
  <el-upload ref="upload"
    :action="upUrl" :headers="postHead"
    :class="isAct"
    :before-upload="prevCtrls"
    :on-success="successCtrls"
    :file-list="imgfiles"
    :disabled="ableSet"
    list-type="picture-card"
    :data="fileData"
    :on-remove="handleRemove"
    :limit="imgNum"
    :on-preview="handlePictureCardPreview"
    :on-exceed="handleExceed">
    <i class="el-icon-plus"></i>
  </el-upload>
  <el-dialog :visible.sync="dialogVisible">
    <img width="100%" :src="dialogImageUrl" alt="">
  </el-dialog>
</div>
</template>

<script>
import {
  getToken
} from '@/utils/auth';
import {
  getFileToken
} from '@/api/account';
import { getPfileUrl } from '@/api/pressRole/pressRole';
export default {
  props: ['ableSure',"limit","viewType"],
  data() {
    return {
      fileData: {},
      imgUrl: '',
      fileToken: '',
      upUrl:'',
      postHead:{},
      dialogVisible:false,
      dialogImageUrl: '',
      imgfiles:[],
      imgIds:[],
      imgmap:{},
      imgNum:1,

      ableSet:false,
      isAct:''
    }
  },
  watch: {
    ableSure: function(dat) {
        console.log("watch ableSure",dat);
        this.imgmap = {};
        this.imgfiles = [];
        this.imgIds = [];
        if(this.ableSure){
          if(!this.fileToken){
            getFileToken().then(response => {
                this.fileToken = response.resultStatus.token;
                var arr = this.ableSure.split(',');
                if(arr.length>0){
                    for(var index in arr){
                        this.imgInit(arr[index]);
                    }
                }
            })
          }else{
            var arr = this.ableSure.split(',');
            if(arr.length>0){
                for(var index in arr){
                    this.imgInit(arr[index]);
                }
            }
          }
          // console.log(dat);

        }
    }
  },
  methods: {
    prevCtrls: function(file) {
      let nameArr = file.type.split('/');
      let fileType = nameArr[nameArr.length - 1];

      if (fileType != 'jpeg' && fileType != 'png') {
        this.$message({
          message: '请上传格式为 JPGE 或 PNG 的文件！',
          type: 'error'
        })
        return false;
      } else if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: '文件大小不能超过 10M！',
          type: 'error'
        })
        return false;
      } else {
        this.postHead['Authorization'] = `Bearer ${getToken()}`;
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        return true;

      }
    },
    successCtrls: function(data) {
      // console.log('我上传成功了,data=',JSON.stringify(data));
      // this.imgIds.push(data.payload.id);

      let dat = data.payload.id;
      getPfileUrl({id: dat}).then(response => {
        let url = response.payload.url
        console.log('url=',url);
        var file = {
          id:dat,
          name: dat + '.jpeg',
          url: url
        }
        this.imgmap[dat]=file;
        this.imgfiles.push(file);
        this.imgIds.push(dat);

        console.log('successCtrls=',JSON.stringify(this.imgIds));

        console.log('this.imgIds.join()=',this.imgIds.join());
        this.$emit('upFileId', this.imgIds.join());
      })

      
    },

    imgInit: function(dat) {
        if(dat){
            if(!this.imgmap[dat]){
                console.log('dat=',JSON.stringify(dat));
                var url;
                getPfileUrl({id: dat}).then(response => {
                  url = response.payload.url
                  console.log('url=',url);
                  // var url = process.env.BASE_API + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
                  var file = {
                    id:dat,
                    name: dat + '.jpeg',
                    url: url
                  }
                  this.imgmap[dat]=file;
                  this.imgfiles.push(file);
                  this.imgIds.push(dat);
                })
                
            }
        }
        console.log("imgInit",this.imgfiles);

    },

    handleExceed: function(files, fileList) {
        // var num = 1;
        // if(this.limit){
        //     this.imgNum=this.limit;
        // }
        //
        // console.log(fileList,files,this.imgNum);
        //
        // if(fileList.length+files.length>this.imgNum){
        //     this.$message({
        //       message: "最多只能上传"+this.imgNum+"个文件!",
        //       type: 'error'
        //     });
        // }
        this.$message({
          message: "最多只能上传"+this.imgNum+"个文件!",
          type: 'error'
        });
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      for(var index in this.imgIds){
        console.log(file.id , ' ' ,this.imgIds[index]);
          if(this.imgIds[index] == file.id ){
            console.log('我是相同的，为啥删除不了呢？')
              this.imgIds.splice(index,1);
          }
      }

      console.log('this.imgIds=',JSON.stringify(this.imgIds));

      this.$emit('upFileId', this.imgIds.join());

    },
  },

  created: function() {
    // this.upUrl = process.env.BASE_API + '/File/File/upload';
    this.upUrl = process.env.BASE_API + '/eavar/file/upload';
    if(this.limit){
        this.imgNum = this.limit;
    }
    if(this.viewType == 2){
        this.ableSet = true;
        this.isAct = 'addHide';
    }
    console.log("created ableSure=",this.ableSure);
    if(!this.fileToken){
        getFileToken().then(response => {
            this.fileToken = response.resultStatus.token;

            if(this.ableSure){

              var arr = this.ableSure.split(',');
              if(arr.length>0){
                  for(var index in arr){
                      this.imgInit(arr[index]);
                  }
              }
            }

        })
    }


  }
}
</script>

<style scope>
.upload-btn {
  display: inline-block;
}

.progressBox {
  width: 480px;
  margin-top: 6px;
}

.imgBox {
  height: 120px;
  margin-bottom: 9px;
}

.imgBox img {
  height: 100%;
}

.addHide .el-upload--picture-card{
  display: none;
}

</style>



// WEBPACK FOOTER //
// uploadCards.vue?f129bc64